export const C = {
  primary: "#1975d1",
  primarySoft: "#eef5fd",
  border: "#e5e7eb",
  bg: "#ffffff",
  text: "#111827",
  textSoft: "#6b7280",
  danger: "#dc2626",
};

export const SCROLL = {
  "&::-webkit-scrollbar": { width: 10, height: 10 },
  "&::-webkit-scrollbar-track": { background: "#f3f4f6", borderRadius: 999 },
  "&::-webkit-scrollbar-thumb": {
    background: "#c7d7ea",
    borderRadius: 999,
    border: "2px solid #f3f4f6",
  },
  "&::-webkit-scrollbar-thumb:hover": { background: "#1975d1" },
  scrollbarWidth: "thin",
  scrollbarColor: "#c7d7ea #f3f4f6",
};
